export const PRESENTATION_MODES = {
  BOTTOM_SHEET: "bottom-sheet",
  DRAWER: "drawer",
  INLINE: "inline",
} as const;

export type PresentationModeType = typeof PRESENTATION_MODES[keyof typeof PRESENTATION_MODES];

export const SETTINGS_TABS = {
  JOBS: "jobs",
  EMPLOYER: "employer",
} as const;

export const SETTINGS_COMPANY_SEARCH = {
  minLength: 2,
  limit: 10,
} as const;

export type SettingsTabType = typeof SETTINGS_TABS[keyof typeof SETTINGS_TABS];
